
import React, { Component } from "react";
import { Checkbox, PageHeader, Button, Slider, Icon } from 'antd';

class FacetBar extends Component{
    //svst start
    onChangeCbStTwoCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStTwo'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbStThreeCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStThree'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbStFourCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStFour'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbStFiveCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStFive'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }

    //svst end
    
    
    sojAndImagesSVUsingQuery(filter, myloc_got){
        console.log('svoct17********myloc_got',myloc_got)
        if(!myloc_got){
            console.log('svoct17********nod 0myloc_got start')
            console.log(this.props)
            console.log(this.props.svfacet_myloc)
           if(this.props.svfacet_myloc && this.props.svfacet_myloc.my_esqueryText !='xx'){
            myloc_got =this.props.svfacet_myloc
            console.log('svoct17********nod 1myloc_got',myloc_got)
           }
           console.log('svoct17********nod 0myloc_got end ')
        }
        console.log('svoct17********nod 2myloc_got',myloc_got)
        const {
            checkedStTwo, checkedStThree, checkedStFour, checkedStFive,
            checkedAct1,checkedAct2, checkedAct3,checkedAct4, checkedAct5,checkedAct6,
            checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
            disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
            checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
            checkedParking,checkedParkingLabel,disabledParking
    
    
            }  = filter
        let qarHW = {"EN_AMENITY_NAME_LVL": "Pool, Health Club"}

        let qarStar = new Array()
    
        if( checkedStTwo && (checkedStTwo == true) ){
            qarStar.push(2)
          
        }
        if( checkedStThree && (checkedStThree == true) ){
            qarStar.push(3)
          
        }
        if( checkedStFour && (checkedStFour == true) ){
            qarStar.push(4)
          
        }
        if( checkedStFive && (checkedStFive == true) ){
            qarStar.push(5)
          
        }
    
        
        let qar = new Array()   
        if( checkedPool && (checkedPool == true) ){
            qar.push('Pool')
          
        }
        if( checkedWifi && (checkedWifi == true) ){
            qar.push('WiFi Available')
        }

        if( checkedRestaurant && (checkedRestaurant == true) ){
            qar.push('Restaurant')
        }
        if( checkedPetfriendly && (checkedPetfriendly == true) ){
            qar.push('Pet Friendly')
        }
        if( checkedRoomservice && (checkedRoomservice == true) ){
            qar.push('Room Service')
        }
        if( checkedFitness && (checkedFitness == true) ){
            qar.push('Health Club')
        }
        if( checkedFrontdesk && (checkedFrontdesk == true) ){
            qar.push('Front desk')
        }
        if( checkedNonsmoking && (checkedNonsmoking == true) ){
            qar.push('Non Smoking')
        }
        if( checkedShuttle && (checkedShuttle == true) ){
            qar.push('Shutle')
        }
        if( checkedFamilyrooms && (checkedFamilyrooms == true) ){
            qar.push('Family Rooms')
        }
        if( checkedSpa && (checkedSpa == true) ){
            qar.push('Spa')
        }
        if( checkedEvcharging && (checkedEvcharging == true) ){
            qar.push('EV Charging')
        }
        if( checkedWheelchair && (checkedWheelchair == true) ){
            qar.push('Wheel Chair')
        }

        /*sv qarAct start*/
        let qarAct = new Array()
        if( checkedAct1 && (checkedAct1 == true) ){
            qarAct.push('Boating')
        }

        if( checkedAct2 && (checkedAct2 == true) ){
            qarAct.push('Fishing')
        }

        if( checkedAct3 && (checkedAct3 == true) ){
            qarAct.push('Golf')
        }
       
        if( checkedAct4 && (checkedAct4 == true) ){
            qarAct.push("Horse Riding")
        }
       
        if( checkedAct5 && (checkedAct5 == true) ){
            qarAct.push('Tennis')
        }

        if( checkedAct6 && (checkedAct6 == true) ){
            qarAct.push('Live Entertainment')
        }
        /*sv qarAct end */
        
        const { startDate, endDate, hotels} = this.props.locationDataView.locationData
        let startDateRq = "", endDateRq = ""
        if(startDate){
            startDateRq = startDate
        }
        if(endDate){
            endDateRq = endDate
        }
        let sojourn_location_s = 'kenServer'
        if(hotels && hotels.values && hotels.values.value){
            sojourn_location_s = hotels.values.value
        }else{

            sojourn_location_s = 'kenServer'
        }
            /*
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)

        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        if(values && values.value){
            sojourn_location_s = values.value
        }
        */
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                    "query": sojourn_location_s,
                    "operator": "and"
                  },
                "startDate": {
                    "query": startDateRq,
                    "operator": "and"
                  },
                  "endDate": {
                    "query": endDateRq,
                    "operator": "and"
                  },
                "checkedWifi": {
                  "query": checkedWifi,
                  "operator": "and"
                },
                "checkedRestaurant": {
                    "query": checkedRestaurant,
                    "operator": "and"
                  },
                  "checkedPetfriendly": {
                    "query": checkedPetfriendly,
                    "operator": "and"
                  }

              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
          /*
          let esRealFacetSearch = {
 
            "query": {
              "bool": {
                "should": [
                  {
                    "match": {
                      "STATE": "WA"
                    }
                  },
                  {
                    "match": {
                      "ADDRESS_LINE1": "Terrace"
                    }
                  },
                  {
                    "match": {
                      "COUNTRY_NAME": "USA"
                    }
                  
                  }
                ]
              }
            },
            "post_filter": {
              "range" : {
                  "STARTDATE": {
                      "gte" : "2023-10-24",
                      "lt" :  "2023-11-27",
                      "time_zone": "+01:00"
                  }
              }
            }
          }
          this.props.sojAndImagesSV(sojPostRq)
          */
         let amen_s = qar.join(', ')
          let esRealPostFIlterSearchCanQuery= {
            "post_filter": {
              "range": {
                "STARTDATE": {
                  "gte": "2023-10-24",
                  "lt": "2023-11-27",
                  "time_zone": "+01:00"
                }
              }
            },
            "query": {
              "bool": {
                "must": {
                  "match": {
                    "EN_AMENITY_NAME_LVL":amen_s
                  }
                }
              }
            }
          }
       // this.props.sojAndImagesSVFacet(esRealPostFIlterSearchCanQuery)
          // "loc": this.props.my_esqueryText  || 'mexico'
          /*
       const {sf_my_esqueryText, sf_locationDataView}   = this.state
       console.log('svoct17********sf_locationDataView', sf_locationDataView)
       console.log('svoct17********sf_my_esqueryText', sf_my_esqueryText)
       */
       let facet_query_svgood_hw = {
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "+01:00",
            "OP": "range"
        },
        "facets": {
           "EN_AMENITY_NAME_LVL.keyword": ["Health Club", "WiFi Available"]
        },
        "loc": myloc_got.my_esqueryText

    }
    let facet_query = {
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "+01:00",
            "OP": "range"
        },
        "facets": {
           "EN_AMENITY_NAME_LVL.keyword": qar
        },
        "loc": myloc_got.my_esqueryText

    }
    let sv_esquery_data = myloc_got
    console.log("svoct17 faetbar calls action ******sv_esquery_data", sv_esquery_data)
   
    if(qarAct && qarAct.length > 0){
       //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct}
       facet_query["facets"]["EN_ACTIVITY_NAME_LVL.keyword"] = qarAct

    }
    //SVR_VEP_RATING
    
    //checkedStFive
   
    if(qarStar && qarStar.length > 0){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct}
        facet_query["facets"]["SVR_VEP_RATING"] = qarStar
 
     }
    this.props.sojAndImagesSVFacet(facet_query, sv_esquery_data)

    }

     /*svoct18 start*/

    onChangeCbAct1Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAct2Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct2 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAct3Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct3 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAct4Curry= (param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('onChangeCbAct4Curry = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct4 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAct5Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct5 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbAct6Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct6 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }

     onChangeCbParkingCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedParking =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
     onChangeCbWifiCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWifi =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
     onChangeCbRestaurantCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRestaurant =e.target.checked

         const comData = f
        
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbPetfriendlyCurry = (param1,ctx) =>(e)=>{
        console.log('svoct17 onChangeCbPetfriendlyCurry got myloac', param1)

        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPetfriendly =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRoomserviceCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRoomservice =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFrontdeskCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFrontdesk =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFitnessCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFitness =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbNonsmokingCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedNonsmoking =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbShuttleCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedShuttle =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFamilyroomsCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFamilyrooms =e.target.checked
         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbSpaCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedSpa =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbEvchargingCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedEvcharging =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbWheelchairCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWheelchair =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbPoolCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPool =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveFacetFilterCheckSuccess(newfacetData)
    }
    /*svoct18 end*/
    /*
    componentDidMount(){
        //this stores parent data as we get only after we are born
        console.log('***svoct17****  componentDidMount get my_esqueryText ')
        console.log('svoct17  componentDidMount gets my_esqueryText ', this.props.my_esqueryText)
        console.log('svoct17  componentDidMount gets locationDataView ', this.props.locationDataView)
        if(this.props.my_esqueryText && this.props.my_esqueryText.length > 1){
            this.setState({
                sf_my_esqueryText:this.props.my_esqueryText,
                sf_locationDataView:this.props.locationDataView,
            })

        }
       
    }
*/
    loadCBValuesFromServer(){
        console.log('sv--calling acction getFacetDataDefaultFromServer')
        let rqOb = {"notnedded":1}
        //this.props.getFacetDataDefaultFromServer(rqOb)
    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        this.loadCBValuesFromServer()
        //console.log(this.props.params)
    }

    constructor(props) {
        super(props)
        let me = this
        this.state = {  
            /*
           sf_my_esqueryText:'mexico',
           sf_locationDataView:{},
            */
            filters: {
                /*svoct18 start*/
               

                checkedAct1Label:'Boating',
                checkedAct1:true,
                disabledAct1:false,
        
                checkedAct2Label:'Fishing',
                checkedAct2:true,
                disabledAct2:false,
        
                checkedAct3Label:'Golf',
                checkedAct3:true,
                disabledAct3:false,
        
                checkedAct4Label:'Horse Riding',
                checkedAct4:true,
                disabledAct4:false,
        
                checkedAct5Label:'Tennis',
                checkedAct5:true,
                disabledAct5:false,
        
                checkedAct6Label:'Live Entertainment',
                checkedAct6:true,
                disabledAct6:false,
                /*svoct18 end*/
                 //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
//svlm start
        checkedLmDisneyLabel:'Disaney Springs',
        checkedLmDisney:true,
        disabledLmDisney:false,


//svlm end
        checkedFbCancellationLabel:'Free Cancellation',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'Free Internet',
        checkedFbInternet:true,
        disabledFbInternet:false,


        checkedFbParkingLabel:'Free Parking',
        checkedFbParking:true,
        disabledFbParking:false,



        checkedFbBreakfastLabel:'Free Nreakfast',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,

         //svrs start
         checkedRsExcellentLabel:'9+  Excellent',
         checkedRsExcellent:true,
         disabledRsExcellent:false,
 
         checkedRsGreatLabel:'8+ Great',
         checkedRsGreat:true,
         disabledRsGreat:false,
 
         checkedRsGoodLabel:'7+  Good',
         checkedRsGood:true,
         disabledRsGood:false,
 
         checkedRsOkayLabel:'5+ Okay',
         checkedRsOkay:true,
         disabledRsOkay:false,
 
         //svrs end

                minBudgetPrice:20,
                maxBudgetPrice:800,
                valueSlider:100,

                checkedParkingLabel:'Parking',
                checkedParking:true,
                disabledParking:false,

                checkedWifiLabel:'Wifi',
                checkedWifi:true,
                disabledWifi:false,

                checkedRestaurantLabel:'Restaurant',
                checkedRestaurant:true,
                disabledRestaurant:false,

                checkedPetfriendlyabel:'pet Friendlly',
                checkedPetfriendly:true,
                disabledPetfriendly:false,

                checkedRoomserviceLabel:'Room Service',
                checkedRoomservice:true,
                disabledRoomservice:false,

                checkedFrontdeskLabel:'24 Hours Front Desk',
                checkedFrontdesk:true,
                disabledFrontdesk:false,

                checkedFitnessLabel:'Fitness Center',
                checkedFitness:true,
                disabledFitness:false,

                checkedNonsmokingLabel:'Non Smoking',
                checkedNonsmoking:true,
                disabledNonsmoking:false,

                checkedShuttleLabel:'Airport Shuttle',
                checkedShuttle:true,
                disabledShuttle:false,

                checkedFamilyroomsLabel:'Family Room',
                checkedFamilyrooms:true,
                disabledFamilyrooms:false,

                checkedSpaLabel:'Spa',
                checkedSpa:true,
                disabledSpa:false,

                checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
                checkedEvcharging:true,
                disabledEvcharging:false,

                checkedWheelchairLabel:'Wheel Chair Accessibility',
                checkedWheelchair:true,
                disabledFWheelchair:false



            }
        }
        this.loadCBValuesFromServer = this.loadCBValuesFromServer.bind(this)
        this.onChangeCbParking = this.onChangeCbParking.bind(me)
        this.onChangeSliderBudget = this.onChangeSliderBudget.bind(me)

    }

    onChangeCbParking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedParking'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)
        //this.setState({filters:f} )

    }
    onChangeCbLmDisney=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedLmDisney'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    //svrs start
    onChangeCbRsOkay=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsOkay'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRsGood=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsGood'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRsGreat=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsGreat'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRsExcellent=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsExcellent'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }

    //svrs end
    
    //svfb start

   
    onChangeCbFbInternet=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbInternet'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFbParking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbParking'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFbBreakfast=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbBreakfast'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }

    //svfb end
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRestaurant=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRestaurant =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
   
    
    onChangeCbPetfriendly=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPetfriendly =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRoomservice=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRoomservice =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFrontdesk=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFrontdesk =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFitness=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFitness =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbNonsmoking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedNonsmoking =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbShuttle=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedShuttle =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFamilyrooms=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFamilyrooms =e.target.checked
         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbSpa=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedSpa =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbEvcharging=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedEvcharging =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbWheelchair=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWheelchair =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbPool=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPool =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)
    }
    /*
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    */
    onChangeSliderBudget(eVal){
        console.log('val = ', eVal);
        let f = this.state.filters
        f['valueSlider'] =eVal

        const comData = f
        let newfacetData = { facetData : comData}
        this.props.saveFacetFilterCheckSuccess(newfacetData)

    }
    

    render(){
        const me = this
        console.log('sv***  Facetbar oct16 this.props')

        const {facetDataView, my_esqueryText} = this.props
        const {facetData} = facetDataView
        console.log(this.props)
        const {myloc} = this.props
       /* if(myloc && myloc.length >1){
            this.setState({my_esqueryText:myloc})
        }*/
        console.log(myloc)
       // console.log(my_esqueryText)
        console.log('sv***  Facetbar oct16 this.props end')
        let facetDataGot 
        if(facetData['facetData']){
            facetDataGot = facetData['facetData']
        }else{
            facetDataGot = facetData
        }
        const {
            
            checkedAct1,checkedAct2, checkedAct3,checkedAct4,checkedAct5,checkedAct6,
            disabledAct1,disabledAct2, disabledAct3,disabledAct4,disabledAct5,disabledAct6,
            checkedAct1Label,checkedAct2Label, checkedAct3Label,checkedAct4Label,checkedAct5Label,checkedAct6Label,
            
            
            checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
            disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
            checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
            checkedParking,checkedParkingLabel,disabledParking,
            checkedLmDisney,checkedLmDisneyLabel,disabledLmDisney,


            checkedFbCancellation,checkedFbCancellationLabel,disabledFbCancellation,
            checkedFbInternet,checkedFbInternetLabel,disabledFbInternet,
            checkedFbParking,checkedFbParkingLabel,disabledFbParking,
            checkedFbBreakfast,checkedFbBreakfastLabel,disabledFbBreakfast,

            checkedStFive,checkedStFiveLabel,disabledStFive,
            checkedStFour,checkedStFourLabel,disabledStFour,
            checkedStThree,checkedStThreeLabel,disabledStThree,
            checkedStTwo,checkedStTwoLabel,disabledStTwo,

            checkedRsGreat,checkedRsGreatLabel,disabledRsGreat,
            checkedRsOkay,checkedRsOkayLabel,disabledRsOkay,
            checkedRsGood,checkedRsGoodLabel,disabledRsGood,
            checkedRsExcellent,checkedRsExcellentLabel,disabledRsExcellent

    
    
            } = facetDataGot
        //const {minBudgetPrice, maxBudgetPrice} =  facetDataGot
        const {valueSlider} =  facetDataGot
       // let valueSlider = 100, 
        let minBudgetPrice = 20, maxBudgetPrice = 800
        const mid = ((maxBudgetPrice - minBudgetPrice) / 2).toFixed(5);
    const preColor = valueSlider >= mid ? '' : 'rgba(0, 0, 0, .45)';
    const nextColor = valueSlider >= mid ? 'rgba(0, 0, 0, .45)' : '';
  

        console.log('sv*** this.props*****facebar')
        const {locationDataView} = this.props
        const {locationData} = locationDataView
        console.log(this.props)
        
        const bdisableDaysBeforeToday = true

        return (
            <div>
                    
                    <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Activities"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>


                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct1}
                                    disabled={disabledAct1}
                                    onChange={this.onChangeCbAct1Curry(myloc, this)}
                                >
                                    {checkedAct1Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct2}
                                    disabled={disabledAct2}
                                   
                                    onChange={this.onChangeCbAct2Curry(myloc, this)}
                                >
                                    {checkedAct2Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct3}
                                    disabled={disabledAct3}
                                    onChange={this.onChangeCbAct3Curry(myloc, this)}
                                >
                                    {checkedAct3Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct4}
                                    disabled={disabledAct4}
                                    onChange={this.onChangeCbAct4Curry(myloc, this)}
                                >
                                    {checkedAct4Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct5}
                                    disabled={disabledAct5}
                                    onChange={this.onChangeCbAct5Curry(myloc, this)}
                                >
                                    {checkedAct5Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct6}
                                    disabled={disabledAct6}
                                    onChange={this.onChangeCbAct6Curry(myloc, this)}
                                >
                                    {checkedAct6Label}
                                </Checkbox>
                            </p>
                         </div>
                    
                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0',
                        fontSize:'14px',
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Budget"
                       
                        subTitle=""
                        >

                    </PageHeader>
                        <div className="icon-wrapper">
                                <Icon style={{ color: preColor }} type="frown-o" />
                                <Slider min={minBudgetPrice} max={maxBudgetPrice} onChange={this.onChangeSliderBudget} value={valueSlider} />
                                <Icon style={{ color: nextColor }} type="smile-o" />
                        </div>
                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Stars"
                       
                        subTitle="">
                        

                    </PageHeader>
                    <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStTwo}
                                    disabled={disabledStTwo}
                                    onChange={this.onChangeCbStTwoCurry( myloc, this)}
                                >
                                    {checkedStTwoLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStThree}
                                    disabled={disabledStThree}
                                    onChange={this.onChangeCbStThreeCurry( myloc, this)}
                                >
                                    {checkedStThreeLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStFour}
                                    disabled={disabledStFour}
                                    onChange={this.onChangeCbStFourCurry( myloc, this)}
                                >
                                    {checkedStFourLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStFive}
                                    disabled={disabledStFive}
                                    onChange={this.onChangeCbStFiveCurry( myloc, this)}
                                >
                                    {checkedStFiveLabel}
                                </Checkbox>
                        </p>

                    </div>    

                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Review Score"
                       
                        subTitle="">
                        

                    </PageHeader>
                    <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsExcellent}
                                    disabled={disabledRsExcellent}
                                    onChange={this.onChangeCbRsExcellent}
                                >
                                    {checkedRsExcellentLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsGreat}
                                    disabled={disabledRsGreat}
                                    onChange={this.onChangeCbRsGreat}
                                >
                                    {checkedRsGreatLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsGood}
                                    disabled={disabledRsGood}
                                    onChange={this.onChangeCbRsGood}
                                >
                                    {checkedRsGoodLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsOkay}
                                    disabled={disabledRsOkay}
                                    onChange={this.onChangeCbRsOkay}
                                >
                                    {checkedRsOkayLabel}
                                </Checkbox>
                        </p>
                    </div>
                    
                        <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Freebies"
                       
                        subTitle=""
                        >
                        <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbCancellation}
                                    disabled={disabledFbCancellation}
                                    onChange={this.onChangeCbFbCancellation}
                                >
                                    {checkedFbCancellationLabel}
                                </Checkbox>
                         </p>
                         <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbBreakfast}
                                    disabled={disabledFbBreakfast}
                                    onChange={this.onChangeCbFbBreakfast}
                                >
                                    {checkedFbBreakfastLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbParking}
                                    disabled={disabledFbParking}
                                    onChange={this.onChangeCbFbParking}
                                >
                                    {checkedFbParkingLabel}
                                </Checkbox>
                         </p>
                         <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbInternet}
                                    disabled={disabledFbInternet}
                                    onChange={this.onChangeCbFbInternet}
                                >
                                    {checkedFbInternetLabel}
                                </Checkbox>
                         </p> 
                   </div>

                    </PageHeader> 
                   <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Landmarks"
                       
                        subTitle=""
                        >
                    <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLmDisney}
                                    disabled={disabledLmDisney}
                                    onChange={this.onChangeCbLmDisney}
                                >
                                    {checkedLmDisneyLabel}
                                </Checkbox>
                            </p>
                   </div>

                        </PageHeader>

                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Amenities"
                       
                        subTitle=""
                        >

                            </PageHeader>
                        
                    <div>

                    <Button onClick={()=>this.sojAndImagesSVUsingQuery(this.state.filters, myloc)} type="dashed" shape="circle" icon="search" />
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedParking}
                                    disabled={disabledParking}
                                    onChange={this.onChangeCbParkingCurry( myloc, this)} 
                                >
                                    {checkedParkingLabel}
                                </Checkbox>
                            </p>
                   </div>
                  
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedWifi}
                                    disabled={disabledWifi}
                                    onChange={this.onChangeCbWifiCurry( myloc, this)} 
                                >
                                    {checkedWifiLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRestaurant}
                                    disabled={disabledRestaurant}
                                    onChange={this.onChangeCbRestaurantCurry( myloc, this)} 
                                >
                                    {checkedRestaurantLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedPetfriendly}
                                    disabled={disabledPetfriendly}
                                    onChange={this.onChangeCbPetfriendlyCurry( myloc, this)} 
                                   
                                >
                                    {checkedPetfriendlyabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRoomservice}
                                    disabled={disabledRoomservice}
                                    onChange={this.onChangeCbRoomserviceCurry( myloc, this)} 
                                >
                                    {checkedRoomserviceLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFitness}
                                    disabled={disabledFitness}
                                    onChange={this.onChangeCbFitnessCurry( myloc, this)} 
                                >
                                    {checkedFitnessLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFrontdesk}
                                    disabled={disabledFrontdesk}
                                    onChange={this.onChangeCbFrontdeskCurry( myloc, this)} 
                                >
                                    {checkedFrontdeskLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedNonsmoking}
                                    disabled={disabledNonsmoking}
                                    onChange={this.onChangeCbNonsmokingCurry( myloc, this)} 
                                >
                                    {checkedNonsmokingLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedShuttle}
                                    disabled={disabledShuttle}
                                    onChange={this.onChangeCbShuttleCurry( myloc, this)} 
                                >
                                    {checkedShuttleLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFamilyrooms}
                                    disabled={disabledFamilyrooms}
                                    onChange={this.onChangeCbFamilyroomsCurry( myloc, this)} 
                                >
                                    {checkedFamilyroomsLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedSpa}
                                    disabled={disabledSpa}
                                    onChange={this.onChangeCbSpaCurry( myloc, this)} 
                                >
                                    {checkedSpaLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedEvcharging}
                                    disabled={disabledEvcharging}
                                    onChange={this.onChangeCbEvchargingCurry( myloc, this)} 
                                >
                                    {checkedEvchargingLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedWheelchair}
                                    disabled={disabledFWheelchair}
                                    onChange={this.onChangeCbWheelchairCurry( myloc, this)} 
                                >
                                    {checkedWheelchairLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedPool}
                                    disabled={disabledPool}
                                    onChange={this.onChangeCbPoolCurry( myloc, this)} 
                                >
                                    {checkedPoolLabel}
                                </Checkbox>
                            </p>
                   </div>
            </div>
        )
    }

}

export default FacetBar